// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__v+PBl","title":"CardHeader_title__e2zxB"};